/** import external dependencies */
import $, { param } from 'jquery';
import 'slick-carousel'

window.$ = $;
window.jQuery = $;

import 'lightGallery';
require('lg-video');
require('lg-thumbnail');

require('pickadate/lib/picker');
require('pickadate/lib/picker.date');

var Inputmask = require('inputmask');
/** import local dependencies */
import './webflow.js';
import './booking-map.js';
import './booking-nav.js';
import picker from 'pickadate/lib/picker';
//import get_data from './booking-map.js'

import "./slider-home";

/**
 * Anonymous function is autoexecutable.
 */
$(document).ready(() => {
  //Breakpoints
  var breakpoint = {};
  breakpoint.refreshValue = function () {
    this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
    return this.value;
  };

  // get google fonts from url and add font-display property
  const loadFont = (url) => {
    // the 'fetch' equivalent has caching issues
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = () => {
        if (xhr.readyState == 4 && xhr.status == 200) {
        let css = xhr.responseText;
        css = css.replace(/}/g, 'font-display: swap; }');

        const head = document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);
        }
    };
    xhr.send();
  }
  loadFont('https://fonts.googleapis.com/css?family=Source+Sans+Pro:200,300,regular,600,700,900|Satisfy');

  //Delete in WP integration
  if($('form').length > 0){
    $('form').parent().removeClass('w-form');
  }

  /*
  * Replace all SVG images with inline SVG
  */
  $('.replace-svg').each(function(){
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.get(imgURL, function(data) {
      // Get the SVG tag, ignore the rest
      var $svg = $(data).find('svg');

      // Add replaced image's ID to the new SVG
      if(typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if(typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass+' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
      if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
        $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
      }

      // Replace image with new SVG
      $img.replaceWith($svg);

    }, 'xml');
  });


  // datepickers and time mask
  var minDate = new Date();
  minDate.setDate(minDate.getDate()+1);
  if($('#arrival-date').length > 0){
    datepicker_populate({
      fromEl:'#arrival-date',
      toEl:'#departure-date',
      format:'mmmm ddth, yyyy',
      formatSubmit: 'yyyy-mm-dd',
      min: [siteData.minDate.y,siteData.minDate.m,siteData.minDate.d]
    });
  }
  if($('.datepicker').length > 0){
    datepicker_populate({
      fromEl:'.datepicker',
      format:'mmmm ddth, yyyy',
      formatSubmit: 'yyyy-mm-dd',
      min: [siteData.minDate.y,siteData.minDate.m,siteData.minDate.d]
    });
  }
  let timeInputs = document.getElementsByClassName('mask-time');
  if(timeInputs.length > 0){
    Inputmask({alias:'datetime',inputFormat:'HH:MM',placeholder:'0'}).mask('.mask-time');
    Object.keys(timeInputs).forEach(function(index) {
      timeInputs[index].addEventListener('focus', (event) => {
        event.target.nextSibling.classList.add('active');
        event.target.placeholder = '00:00 24hrs format';
      }, true);
      timeInputs[index].addEventListener('blur', (event) => {
        event.target.nextSibling.classList.remove('active');
      }, true);
    });
  }

  //Cities slick
  var citiesWrapperSlick = false;

  function onResponsive() {
    breakpoint.refreshValue();
    //console.log('breakpoint', breakpoint.refreshValue());
    var citiesWrapper = $('.cities-wrapper');

    switch (breakpoint.refreshValue()){
      case '1920':

        if (citiesWrapperSlick) {
          citiesWrapperSlick.slick('unslick');
          citiesWrapperSlick = false;
        }

      break;
      case '1024':

        if (citiesWrapperSlick) {
          citiesWrapperSlick.slick('unslick');
          citiesWrapperSlick = false;
        }

      break;
      case '767':

        citiesWrapperSlick = citiesWrapper.slick({
          arrows       : false,
          autoplay     : false,
          dots         : true,
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1,
          adaptiveHeight: true,
          rows: 0
        });

      break;
      case '479':

        citiesWrapperSlick = citiesWrapper.slick({
          arrows       : false,
          autoplay     : false,
          dots         : true,
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1,
          adaptiveHeight: true,
          rows: 0
        });

      break;
    }
  }
  onResponsive();
  $(window).on('resize', onResponsive);

  if($('#bookingStep1 .select').length > 0){
    var firstInput = $('#bookingStep1 .select input[name="origin"]')[0];
    $(firstInput).trigger('click').addClass('open');

  }

  $($('#bookingStep1 .select input[name="origin"]')).click(function(){
    $($('#bookingStep1 .select input[name="origin"]')[0]).toggleClass('open');
    if($($('#bookingStep1 .select input[name="origin"]')[0]).hasClass('open')){
    }else{
      $('#bookingStep1 .select input[name="origin"]')[0].checked = false;
    }
  });

  let input_code = document.getElementById('discount-code');
  if(input_code != undefined) {
    input_code.addEventListener('keyup', (e) => {
      input_code.value = input_code.value.toUpperCase();
    });
  }
});

/*
 * pickadate handler for from-to datepickers
 */
function datepicker_populate(params){
  params.hiddenName = true;
  if(siteData.langCode == 'es'){
    var translations = {
      monthsFull: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
      today: 'hoy',
      clear: 'restablecer',
      close: 'cerrar'
    }
  }else{
    var translations = {}
  }
  Object.assign(params, translations);
  if(params.toEl){
    var checkout = $( params.toEl ).pickadate(params);
    var checkout_object = checkout.pickadate('picker');
    params.onSet = function( context ) {
      checkout_object.set( 'enable', true );
      checkout_object.set( 'disable', [
        { from: [0,0,0], to: new Date(context.select) },
      ]);
    }
  }
  $( params.fromEl ).pickadate(params);
}

function handleURLParams() {
  const query = window.location.search;
  const params = new URLSearchParams(query);

  // Set the date for arrival & departure date.
  if ( params.get('arrival_date') ) {
    $('#arrival-date').data('value', params.get('arrival_date') );

    // Update departure date to reflect arrival date as the minimum
    var departure_min = params.get('arrival_date').split('-');
    departure_min[1] = parseInt(departure_min[1]) - 1;

    datepicker_populate({
      fromEl:'#arrival-date',
      toEl:'#departure-date',
      format:'mmmm ddth, yyyy',
      formatSubmit: 'yyyy-mm-dd',
      min: departure_min,
    });
  }
  if ( params.get('departure_date') ) {
    $('#departure-date').data('value', params.get('departure_date') );
  }
  if ( params.get('round_trip') ) {
    $('#round-trip').prop('checked', true);
    $('.form-toggle-button').addClass('opened');
    $('#departure-wrapper').addClass('active');
    $('[data-conditional="round-trip"]').removeAttr('disabled');
    $('[data-conditional="round-trip"]').siblings().removeAttr('disabled');
  }
}
handleURLParams();
